import styled from "styled-components";

export const EmptyModalWrapper = styled.div`
  width: 100%;
  height: 100%;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const EmptyModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 10px;

  svg {
    width: auto;
    max-width: 100%;
    height: 40px;

    @media only screen and (max-width: 767px) {
      height: 30px;
    }
  }

  p {
    margin: 0;
  }
`;